module.exports = __webpack_public_path__ + "img/customer_first_menu_1.90a028a8.png";